/*
fancyboxが開いた状態でリロードすると#hashが付与されていて前回開いた状態になるが
その場合gallery名を表示できないので、リロードしたら閉じるように#を削除
*/
const hash = window.location.hash;
if (hash && (hash.indexOf('gallery') > 0)) {
  history.replaceState('', '', './');
}

const posts = document.querySelectorAll('main .wp-block-image a');
const links = document.querySelectorAll('.gallery-item');
const body = document.querySelector('body');

let eventType;
function isTouch() {
  eventType = 'click';
  let touch_event = window.ontouchstart;
  let touch_points = navigator.maxTouchPoints;

  if (touch_event !== undefined && 0 < touch_points) {
    eventType = 'touchstart';
  }
}
isTouch();


window.addEventListener('load', () => {

  let current_gallery_name;
  //ギャラリーごとにひとまとめにする（本来fancyboxで可能なはずだがバグで動作せず・issue報告済）
  //data-fancyboxの属性指定をload直後に行うとEdgeのみ不具合がでる->200ms後に変更
  //Edgeだけじゃなかった模様（Win Chromeも）。ブラウザでなくPCの処理速度の問題??
  if(posts){
    Array.from(posts).forEach((p) => {
      const init = setInterval(function(){
        current_gallery_name = p.getAttribute('data-fancybox-group');
        p.setAttribute('data-fancybox', current_gallery_name);
        setTimeout(function () {
          clearInterval(init);
        }, 600);
      }, 200);
      
      p.addEventListener(eventType, () => {
        current_gallery_name = p.getAttribute('data-fancybox-group');
        //body.classList.add('is_open_' + current_gallery_name);
        const searchElm = setInterval(function () {
          const lightbox_wrapper = document.querySelectorAll('.fancybox-content');
        
          if (lightbox_wrapper.length >= 1) {
            Array.from(lightbox_wrapper).forEach((l) => {
              l.setAttribute('data-gallery-type', current_gallery_name);
            })
          }
          setTimeout(function () {
            clearInterval(searchElm);
          }, 600);
        }, 200);
      });
    });
  }


  //各項目のリンク アーカイブだけ
  if(links && body.classList.contains('post-type-archive-gallery')){
    Array.from(links).forEach((link) => {
      let href =  link.querySelector('a').getAttribute('href');
      if(hash === href){
        link.classList.add('current-item-by-hash');
      }
      link.addEventListener(eventType, () => {
        if(!link.classList.contains('current-item')){
          const siblings = Array.from(link.parentNode.children).filter(function(child) {
            return child !== link;
          });

          Array.from(siblings).forEach((s) => {
            var classNames = s.className.split(' ');
            // 特定のクラス名以外のクラス名をフィルタリングして残すクラス名のみの配列を作成
            var filteredClassNames = classNames.filter(function(className) {
                return className === 'gallery-item' || className.trim() === '';
            });
            s.className = filteredClassNames.join(' ');
          });

          link.classList.add('current-item');
        }
      });
    });
  }
});

/*
//wordpress管理画面  Fancyboxのmiscで Clean upに以下設定（bodyのクラスを削除）
//-> 英語表示が不要になったので不要

function() {
  const body = document.querySelector('body');
  if (body.classList.contains('post-type-archive-gallery') || body.classList.contains('tax-gallery-category')) {
    const classNames = body.className.split(' ');
    const prefixToRemove = 'is_open_gallery-';
    const filteredClassNames = classNames.filter(function (className) {
      return !className.startsWith(prefixToRemove);
    });
    body.className = filteredClassNames.join(' ');
  }
}
*/